<template>
  <div>
    <v-container class="text-center">
      <v-container>
        <v-tabs show-arrows center-active fixed-tabs hide-slider color="primary">
          <v-tab :disabled="retrievingData" @click="getData('today')">Heute</v-tab>
          <v-tab :disabled="retrievingData" @click="getData('yesterday')">Gestern</v-tab>
          <v-tab :disabled="retrievingData" @click="getData('currentMonth')">Aktueller Monat</v-tab>
          <v-tab
            @click="getData('currentMonthPrognose')"
            :disabled="retrievingData"
          >Aktueller Monat (Prognose)</v-tab>
          <v-tab :disabled="retrievingData" @click="getData('lastMonth')">Letzter Monat</v-tab>
        </v-tabs>
      </v-container>

      <v-container class="text-right">
        <v-card class="mx-auto elevation-1" max-width="1000">
          <v-toolbar color="primary" dark>
            <v-toolbar-title>{{currentDate}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon>
              <v-icon>mdi-dots-horizontal</v-icon>
            </v-btn>
          </v-toolbar>

          <v-container class="text-left pa-4">
            <v-row no-gutters>
              <v-card width="50%" class="pl-12 pt-4 elevation-0 text--secondary" tile>Umsatz</v-card>
              <v-card width="50%" class="pl-12 pt-4 elevation-0 text--secondary" tile>Einheiten</v-card>
              <v-card width="50%" class="pl-12 pt-4 elevation-0" tile>{{generalTurnOver}}</v-card>
              <v-card width="50%" class="pl-12 pt-4 elevation-0" tile>{{unitCount}}</v-card>
            </v-row>
          </v-container>
        </v-card>
      </v-container>

      <v-container class="mt-3">
        <v-data-table
          :headers="salesTableHeaders"
          :items="dataList"
          :items-per-page="10"
          :loading="retrievingData"
          loading-text="Loading... Please wait"
          class="elevation-1"
        />
      </v-container>
    </v-container>
  </div>
</template>

<script>
import * as salesApi from "../api/sales.js";

export default {
  name: "salesData",

  data: function() {
    return {
      retrievingData: Boolean,
      currentDate: String,
      unitCount: Number,
      generalTurnOver: Number,
      dataList: [],
      salesTableHeaders: [
        { text: "Produkt", value: "ArticleName" },
        { text: "Einheiten", value: "Qty" },
        { text: "Umsatz", value: "Turnover" },
        { text: "Artikelnr.", value: "ArticleNr" }
      ]
    };
  },

  // computed: {
  //   turnover() {
  //     return 0
  //   }
  // },

  created() {
    this.getData("today");
  },

  methods: {
    getData: async function(timeIndex) {
      // early return
      if (this.retrievingData == true) return;

      // empty the datalist as soon as user clicks on another tab
      if (this.dataList.length > 0) this.dataList = [];

      let FromDate;
      let ToDate;

      let dayjs = require("dayjs");
      let now = dayjs();

      // set FromDate & ToDate accordingly to time index
      switch (timeIndex) {
        case "today":
          FromDate = now.startOf("day");
          ToDate = now;
          this.currentDate = ToDate.format("DD.MM.YYYY");

          break;

        case "yesterday":
          FromDate = now.subtract(1, "day").startOf("day");
          ToDate = now.subtract(1, "day").endOf("day");
          this.currentDate = ToDate.format("DD.MM.YYYY");

          break;

        case "currentMonth":
          FromDate = now.startOf("month");
          ToDate = now;
          this.currentDate =
            FromDate.format("DD.MM.YYYY") + " - " + ToDate.format("DD.MM.YYYY");

          break;

        case "currentMonthPrognose":
          FromDate = now.startOf("month");
          ToDate = now;
          this.currentDate =
            FromDate.format("DD.MM.YYYY") +
            " - " +
            ToDate.format("DD.MM.YYYY") +
            " (Prognose)";
          break;

        case "lastMonth":
          FromDate = now.subtract(1, "month").startOf("month");
          ToDate = now.subtract(1, "month").endOf("month");
          this.currentDate =
            FromDate.format("DD.MM.YYYY") + " - " + ToDate.format("DD.MM.YYYY");
          break;

        default:
          this.currentDate = now.format("DD.MM.YYYY");

          FromDate = now.startOf("day");
          ToDate = now;
          break;
      }

      // format FromDate & ToDate (to ISO String for database)
      FromDate = FromDate.format();
      ToDate = ToDate.format();

      try {
        this.retrievingData = true;

        // await response of DB
        const response = await salesApi.retrieveDataFromFirebird(
          FromDate,
          ToDate
        );

        // DB response was successfull
        if (response.data.success == true) {
          this.dataList = response.data.datas;

          this.generalTurnOver = this.unitCount = 0;

          this.dataList.forEach(element => {
            // determine general turnover
            this.generalTurnOver += Number(element.Turnover);
            // determine unit count
            this.unitCount += element.Qty;

            //element.qty = element.qty.toLocaleString("de");

            // format turnover
            element.Turnover = new Intl.NumberFormat("de-DE", {
              style: "currency",
              currency: "EUR"
            }).format(element.Turnover);
          });

          // format generalTurnOver in German currency
          this.generalTurnOver = new Intl.NumberFormat("de-DE", {
            style: "currency",
            currency: "EUR"
          }).format(this.generalTurnOver);

          // format unitCount
          this.unitCount = this.unitCount.toLocaleString("de");
        } else {
          this.dataList = [];
          console.log("DB response failed");
        }
      } catch (err) {
        console.log(err);
        this.dataList = [];
      } finally {
        this.retrievingData = false;
      }
    }
  }
};
</script>
